var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadrons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3161 22.6106C19.8288 22.6106 21.8657 20.5737 21.8657 18.061C21.8657 15.5484 19.8288 13.5115 17.3161 13.5115C14.8035 13.5115 12.7666 15.5484 12.7666 18.061C12.7666 20.5737 14.8035 22.6106 17.3161 22.6106Z",
    stroke: "#404040",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7189 33.0857C25.7189 29.3133 21.9627 26.2371 17.316 26.2371C12.6693 26.2371 8.91309 29.2971 8.91309 33.0857",
    stroke: "#404040",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.762 20.6191C32.762 29.1191 25.8811 36.0001 17.381 36.0001C8.88098 36.0001 2 29.1191 2 20.6191C2 12.119 8.88098 5.23804 17.381 5.23804C19.502 5.23804 21.5258 5.65898 23.3715 6.43612C23.161 7.08374 23.0477 7.76376 23.0477 8.47615C23.0477 9.69044 23.3877 10.84 23.9868 11.8114C24.3106 12.3619 24.7315 12.8637 25.2172 13.2847C26.3506 14.3209 27.8563 14.9524 29.5239 14.9524C30.2363 14.9524 30.9163 14.839 31.5477 14.6123C32.3249 16.458 32.762 18.4981 32.762 20.6191Z",
    stroke: "#404040",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9998 8.47622C35.9998 8.99431 35.935 9.49621 35.8055 9.98193C35.6598 10.6295 35.4007 11.261 35.0607 11.8115C34.2836 13.1229 33.0369 14.1429 31.5474 14.6124C30.916 14.8391 30.236 14.9524 29.5236 14.9524C27.856 14.9524 26.3502 14.321 25.2169 13.2848C24.7312 12.8638 24.3102 12.3619 23.9864 11.8115C23.3874 10.84 23.0474 9.69051 23.0474 8.47622C23.0474 7.76383 23.1607 7.08381 23.3712 6.43619C23.6788 5.49714 24.1969 4.65528 24.8769 3.95909C26.0588 2.7448 27.7102 2 29.5236 2C31.4341 2 33.1665 2.82575 34.3322 4.15337C35.3684 5.3029 35.9998 6.82478 35.9998 8.47622Z",
    stroke: "#404040",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9366 8.44385H27.1118",
    stroke: "#404040",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5244 6.08008V10.921",
    stroke: "#404040",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadrons);
export default __webpack_public_path__ + "static/media/padrons.19ba7ed51697ac01c1098f4778c23cf1.svg";
export { ForwardRef as ReactComponent };